define('controllers/hr',['require','flashDetect','layout'],function (require) {
    require('flashDetect');
    var layout = require('layout');
    return {
        load: function () {
            function init() {
                layout.hideMatchPlanTemplate();
                $('[data-800SalesDesk]').text(window.ServerData.Phones.SalesDesk800);
                $("[data-matchPlanPercentage]").text(window.ServerData.Settings.MatchPercentage);
                $('#emailLink')
                    .attr('href', '/#/contact/?subject=Sales%20Inquiries&to={0}'.format(window.ServerData.Emails.SalesEmail))
                    .text(window.ServerData.Emails.SalesEmail);

                var contactForm = $("#contactForm"),
                    submitContactInfo = $("#submitContactInfo"),
                    contactFormBoxes = $("input[type='text'], select", contactForm);

                submitContactInfo.on("click", function () {
                    //be sure all boxes filled, email is good pattern and employee count is integer
                    var msg = $("#msg", contactForm);
                    if (validateForm()) {
                        submitContactInfo.prop('disabled', true);
                        var source = "&url=" + window.location.toString();
                        $.post("/hr/hrajax.aspx", contactFormBoxes.serialize() + source, function (response) {
                            Utilities.handleAJAXResponse(response,
                                function (success) {
                                    Utilities.setInfo("Your information has been submitted. We'll get back to you ASAP. Thanks!", msg);
                                },
                                function (error) {
                                    Utilities.setError(error, msg);
                                });
                        }).complete(function () {
                            submitContactInfo.prop('disabled', false);
                        });
                    } else {
                        Utilities.setError("Please input valid values in the fields marked in red.", msg);
                    }
                });

                contactFormBoxes.on("change", function () { validateForm($(this).attr("name")); });

                function validateForm(changeName) {
                    var valid = true;
                    for (var i = 0, length = contactFormBoxes.length; i < length; i++) {
                        var box = $(contactFormBoxes[i]),
                            name = box.attr("name"),
                            value = box.val().trim();
                        if (changeName == undefined || changeName == name) {
                            if (name != "source" &&
                                (
                                    (value == "" || value == box.attr("placeholder")) ||
                                    (name == "email" && !new RegExp(window.ServerData.Regex.Email).test(box.val()))
                                )
                            ) {
                                validateBox(box, false);
                                valid = false;
                            } else {
                                validateBox(box, true);
                            }
                        }
                    }
                    return valid;
                }

                function validateBox(box, valid) {
                    box.css("border", valid ? "" : "2px solid #6E0A03");
                }

                window.populateAudienceText = function () {
                    var newAudiance = document.getElementById('audience').value;
                    document.getElementById('audienceText').value = newAudiance;
                }

                //$("#btnVideo, #btnVideo2").attr("href", FlashDetect.installed ? "https://player.vimeo.com/video/65221554/?autoplay=yes"
                //                                                              : "http://player.vimeo.com/video/65221554/?autoplay=yes"); //"http://pdl.vimeocdn.com/48304/980/161714969.mp4?aksessionid=4f6c2c44504bca18b97697dc86ec9cb7&token=1367425069_c879ab8e09fa066e4a35c31ae4de581a&autoplay=yes");
                ////"https://secure.vimeo.com/moogaloop.swf?clip_id=45672328&autoplay=yes" : "http://player.vimeo.com/video/45672328");

                $("#btnVideo").fancybox(Utilities.specialFancy);

                Utilities.setDefaultButton(contactForm, submitContactInfo);
            }

            var contentFile = '/fe/templates/about/' + (/hotel/i.test(window.location) ? 'hotelinfo' : 'hr');
            return layout.initStatic(contentFile, 3).then(init);
        },

        unload: function () {
            $("#submitContactInfo").off('click');
            var contactForm = $("#contactForm");
            $("input[type='text'], select", contactForm).off('change');
            window.Utilities.unSetDefaultButton(contactForm);
            $("#btnVideo").off();
        }
    };
});

